import React, { useContext } from "react";
import {
  Box,
  Checkbox,
  InputAdornment,
  styled,
  Typography,
} from "@mui/material";
import { Context } from "../../context/context";
import { MemoizedButton } from "../../SDK/button";
import { MemoizedPhoneField } from "../../SDK/input/phoneInput";
import { checkError } from "../../SDK/utils/validationHelpers";
import useLoanFormPopup from "../../Drawer/hooks/useDiscountDrawer";
const CustomMobilePopUp = styled(Box)(({ theme }) => ({
  width: "100%",
  ".form-box": {
    margin: " 30px 0px",
  },
  ".head-text-box": {
    margin: "20px",
    textAlign: "center",
  },
  ".view-btn": {
    borderRadius: "8px",

    boxShadow: "none",
    border: "none",
    paddingLeft: "20px",
    paddingRight: "20px",
    "&:hover": {
      background: "#F63B63",
      border: "none",
      color: "white",
      boxShadow: "none",
      paddingLeft: "20px",
      paddingRight: "20px",
    },
  },
  ".MuiOutlinedInput-root": {
    paddingRight: "2px !important",
    background: "#FEEBEF",
    borderRadius: "4px",
  },

  ".head-text": {
    fontSize: "20px",
    fontWeight: "600",
  },
  ".termsconditions": {
    alignSelf: "center",
    fontSize: "10px",
  },
  ".input-field": {
    minWidth: "100% !important",
    paddingRight: "0px",
    borderRadius: "8px",
    overflow: "hidden",
    borderRadius: "0px, 8px, 8px, 0px",
  },
  [theme.breakpoints.down("sm")]: {
    ".input-field": {
      fontSize: "12px",
    },
    ".form-box": {
      margin: "20px 0",
    },
  },
}));
const MobileForm = ({ onClose }) => {
  const { form, loading } = useLoanFormPopup();

  return (
    <>
      <CustomMobilePopUp>
        <Box className="form-box">
          <form onSubmit={form.handleSubmit}>
            <Box className="input-box">
              <MemoizedPhoneField
                error={!!checkError("mobile", form)}
                helperText={form.errors.mobile}
                className="input-field"
                name="mobile"
                placeholder="Your Mobile"
                value={form.values.mobile}
                onChange={(e) => {
                  form.handleChange(e);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">+91</InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <MemoizedButton
                        className="view-btn"
                        type="submit"
                        content="Check Vehicle"
                        loading={loading}
                        handleClick={(e) => {
                          form.handleSubmit(e, false);
                          onClose();
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />

              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                      color: "white",
                      fontColor: "black",
                      background: "#35BF68",
                    },
                  }}
                  checked={true}
                  onChange={() => {
                    const currCheckboxValue = form.values.checkbox;
                    form.setFieldValue("checkbox", !currCheckboxValue);
                  }}
                  name="checkbox"
                />

                <Typography className="termsconditions">
                  By continuing, you’re agreeing to our Customer terms of
                  service, User terms of Service, and Privacy policy.
                </Typography>
              </Box>
            </Box>
          </form>
        </Box>
      </CustomMobilePopUp>
    </>
  );
};

export default MobileForm;
